<template>
  <div>
    <!-- :get-form-data="fromData" -->
    <list
      row-key="details"
      ref="list"
      unit="工单产品明细表"
      :page="page"
      :show-query="true"
      :get-data-func="api.getWdmExecution"
      :trendParams="trendParams"
      v-if="trendShow"
      urlHash="production/ticketmanagement/materialsexecute"
    >
      <template slot="toolbar-right">
        <slot name="toolbar-right"></slot>
      </template>
      <template slot="table">
        <slot name="column"></slot>
      </template>
    </list>
  </div>
</template>
<script>
import listMixin from "@/mixins/trend/list";
import list from "@/components/common/trendsTable/list";


export default {
  mixins: [listMixin],
  components: { list },
  data() {
    return {
      api: require('@/api/production/workDoc').default,
      trendShow: true,
    };
  },
};
</script>
